export default "__VITE_ASSET__BocezH2j__"